import type { SVGProps } from "react";

export function Spark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      fill="currentColor"
      {...props}
    >
      <rect x="492.52" y="807.73" width="55.31" height="197.21" />
      <rect x="634.51" y="807.73" width="55.31" height="149.51" />
      <rect
        x="329.8"
        y="801.28"
        width="55.31"
        height="207.96"
        transform="translate(-572.55 618.26) rotate(-51.3)"
      />
      <rect
        x="1496.35"
        y="862.88"
        width="95.86"
        height="166.19"
        transform="translate(-159.51 1559.79) rotate(-51.3)"
      />
      <polygon points="1526.2 991.04 1450.75 931.92 1673.04 648.23 1673.01 653.02 1526.2 991.04" />
      <polygon points="1417.73 1242.89 1414.34 1243.95 1564.56 900.08 1640.02 959.2 1417.73 1242.89" />
      <rect
        x="1673.06"
        y="878.2"
        width="62.97"
        height="109.16"
        transform="translate(-223.05 1177.61) rotate(-35.93)"
      />
      <polygon points="1685.25 958.18 1647.75 907.59 1837.94 766.64 1837.09 769.67 1685.25 958.18" />
      <polygon points="1572.69 1098.79 1570.36 1098.87 1725.38 907.25 1762.87 957.83 1572.69 1098.79" />
      <rect
        x="1264.51"
        y="829.78"
        width="55.31"
        height="195.58"
        transform="translate(-219.31 1423.05) rotate(-53.82)"
      />
      <rect
        x="1252.86"
        y="838.23"
        width="131.98"
        height="55.31"
        transform="translate(-258.63 892.13) rotate(-34.24)"
      />
      <rect x="258.58" y="806.66" width="197.21" height="55.31" />
      <rect x="492.42" y="806.66" width="197.76" height="55.31" />
      <rect x="492.61" y="902.21" width="197.21" height="55.31" />
      <rect x="958.49" y="807.73" width="55.31" height="197.21" />
      <rect x="1100.38" y="807.73" width="55.31" height="149.51" />
      <rect x="958.49" y="806.66" width="197.21" height="55.31" />
      <rect x="958.49" y="902.21" width="197.21" height="55.31" />
      <rect x="725.35" y="807.73" width="55.31" height="197.21" />
      <rect x="1191.85" y="807.73" width="55.31" height="197.21" />
      <rect x="867.24" y="807.73" width="55.31" height="197.21" />
      <rect x="725.35" y="806.66" width="197.21" height="55.31" />
      <rect x="725.35" y="902.21" width="197.21" height="55.31" />
      <rect x="725.35" y="1039.69" width="55.31" height="197.21" />
      <rect x="867.24" y="1039.69" width="55.31" height="197.21" />
      <rect x="1027.08" y="1039.69" width="55.31" height="197.21" />
      <rect x="725.35" y="1038.63" width="197.21" height="55.31" />
      <rect x="725.35" y="1182.9" width="197.21" height="55.31" />
      <rect x="258.58" y="949.26" width="197.21" height="55.31" />
      <rect
        x="329.8"
        y="1035.6"
        width="55.31"
        height="207.96"
        transform="translate(-755.42 706.08) rotate(-51.3)"
      />
      <rect x="258.58" y="1040.98" width="197.21" height="55.31" />
      <rect x="258.58" y="1183.58" width="197.21" height="55.31" />
      <rect
        x="1184.5"
        y="1111.92"
        width="207.96"
        height="55.31"
        transform="translate(-429.6 1055.76) rotate(-38.7)"
      />
      <rect x="1190.14" y="1040.98" width="197.21" height="55.31" />
      <rect x="1190.14" y="1183.58" width="197.21" height="55.31" />
      <rect x="492.52" y="1041.36" width="55.31" height="197.21" />
      <rect x="634.51" y="1041.36" width="55.31" height="149.51" />
      <rect x="492.61" y="1040.3" width="197.21" height="55.31" />
      <rect x="492.61" y="1135.84" width="197.21" height="55.31" />
      <polygon points="1157.54 1004.58 1086.88 919.35 1044.3 954.65 1085.69 1004.58 1157.54 1004.58" />
      <rect x="958.49" y="1038.63" width="197.21" height="55.31" />
    </svg>
  );
}
